import { Component, Vue, Watch } from 'vue-property-decorator';
import moment from "moment";
import {ShippingDestinationList,ShippingRecordHarvestRecord,LoginUser} from "@/types/Component"
import EmptyGraphMessage from '@/assets/common/AggregationFunction/EmptyGraphMessage/EmptyGraphMessage.vue';
import ShippingcollectiveRegisterModal from '@/components/AdditionalFunction/ShippingcollectiveRegisterModal/ShippingcollectiveRegisterModal.vue'
import ShippingRecordModal from '@/assets/common/Modal/ShippingRecordModal/ShippingRecordModal.vue';


@Component({
    components: {
        EmptyGraphMessage,
        ShippingcollectiveRegisterModal,
        ShippingRecordModal
    }
})
export default class ShippingCollectiveRegisterList extends Vue {
    shippingDestinationScreen = 'SHIPPINGRECORDREGISTERCOLLECTIVEDESTINATION';
    baseUrl = '/admin/shipping_record_register_collective';
    shippingDestinationUrl ='destination_list'
     isButtonDisabled = false;
    includeHiddenFlag = false;
    selectedStartDate: string | Date = new Date();
    selectedEndDate: string | Date = new Date();
    startDate: string | Date = new Date();
    endDate: string | Date = new Date();
    selectScreenManagement = '/graphScreenManagement';
    selectedCropOrPlantingId : string | null = null;
    selectedPlantingOrCropName = "";
    selectedPlantingsOrCrops = 0;
    lastSetOption = false;
    plantings = [];
    crops = [];
    plantingsOrCrops = [] as any[];
     shippingDestinationList =[] as ShippingDestinationList[];
     selectedShippingDestinationName = "" as any;
     selectedDestinationId = null;
    selectedPlantingId :string | null = null
    shippingRegisterCollectiveDestinationList = []
    isDestinationSpinnerLoading = false;
    includeHiddenDateListFlag = false;
    includeShippingCreationFlag = false;
    selectedDateListStartDate: string | Date = new Date();
    selectedDateListEndDate: string | Date = new Date();
    dateListStartDate: string | Date = new Date();
    dateListEndDate: string | Date = new Date();
    selectedDateListCropOrPlantingId : string | null = null;
    selectedDateListPlantingOrCropName = "";
    selectedDateListPlantingsOrCrops = 0;
    lastSetDateListOption = false;
    dateListPlantings = [];
    dateListCrops = [];
    dateListPlantingsOrCrops = [] as any[];
    selectedDateListPlantingId :string | null = null
    shippingDatescreen = 'SHIPPINGRECORDREGISTERCOLLECTIVEDATE';
    shippingDateUrl ='date_list'
    private isDateListButtonDisabled = false;
    shippingRegisterCollectiveDateList = []
    private isDateSpinnerLoading = false;
    private sortOrderByDestination = true;
    private sortOrderByDate = true;
    showShippingCollectiveRegister = false
    private isRefresh = false;
    modeType = ''
    shippingCollectiveIds : [] =[]
    isShippingModalShow = false
    private apiBaseUrl = '/admin/shipping_record_register_collective'
    shippingCollectiveRecordDetails =[]
    shippingSplitIds :[] =[]
    shippingDestinationTab = false
    shippingDateTab = false

    get isShippingCollectiveListModalOpen():boolean{
       return(
        this.showShippingCollectiveRegister ||
        this.isShippingModalShow
       )
    }


    created() {
        this.isDestinationSpinnerLoading = true
        this.isDateSpinnerLoading =true
        const currentDate = new Date();
        this.selectedStartDate = moment(currentDate).startOf('month').format('YYYY-MM-DD');
        this.selectedEndDate = moment(currentDate).endOf('month').format('YYYY-MM-DD');
        this.startDate = this.selectedStartDate;
        this.endDate = this.selectedEndDate;
        this.selectedDateListStartDate = moment(currentDate).startOf('month').format('YYYY-MM-DD');
        this.selectedDateListEndDate = moment(currentDate).endOf('month').format('YYYY-MM-DD');
        this.dateListStartDate = this.selectedDateListStartDate;
        this.dateListEndDate = this.selectedDateListEndDate;
        this.getShippingDestination()
        this.getPlantings()
        this.getCrops()
        this.getShippingRegisterListByDestination();
        this.getShippingRegisterListByDate();
        this.shippingDestinationTab = true;
    }

    refreshTable (type:string) {
        if(type === 'destination'){
        this.shippingRegisterCollectiveDestinationList = []
        this.getShippingRegisterListByDestination();
        }else if(type === 'date'){
        this.shippingRegisterCollectiveDateList = []
        this.getShippingRegisterListByDate();
        }
        else{
        this.getShippingRegisterListByDestination();
        this.getShippingRegisterListByDate();
        }
    }

    get isAdmin(): boolean {
        return this.loginUser.role.find((r: string) => {
            return r === 'ADMIN'
        }) !== undefined;
      }
    
    get loginUser(): LoginUser {
        return this.$store.getters.loginUser;
    } 
    
    getShippingDestination(){
        this.$apiClient.doRequest('get', `/admin/shipping_destinations?with_hidden=true`).then(ret => {
            this.shippingDestinationList = ret.shipping_destinations;
            this.selectedShippingDestinationName= this.shippingDestinationList.find(item=>item.id==this.selectedDestinationId)?.name
        })
    }

    getPlantings(){
        this.$apiClient.doRequest('get', '/plantings?with_hidden=true').then((res) => {
            this.plantings = res.plantings.sort((a:any,b:any) => a.name.localeCompare(b.name));
            this.plantingsOrCrops = !this.selectedPlantingsOrCrops ? this.plantings : this.crops
            this.dateListPlantingsOrCrops = !this.selectedDateListPlantingsOrCrops ? this.plantings : this.crops
        })
    }

    getCrops(){
        this.$apiClient.doRequest('get', `/crops/cropBytenentId`).then(res => {
            this.crops = res.crops;
            this.crops.sort((a:any, b:any) => a.name.localeCompare(b.name));
            this.plantingsOrCrops = !this.selectedPlantingsOrCrops ? this.plantings : this.crops
            this.dateListPlantingsOrCrops = !this.selectedDateListPlantingsOrCrops ? this.plantings : this.crops
            this.selectedPlantingOrCropName= this.plantingsOrCrops.find(item=>item.id==this.selectedCropOrPlantingId)?.name
            this.selectedDateListPlantingOrCropName= this.dateListPlantingsOrCrops.find(item=>item.id==this.selectedDateListCropOrPlantingId)?.name
        })
    }

    dateNavigation(action: string) {
        if (!this.selectedStartDate || !this.selectedEndDate) return;
        this.validateDates("destination")
        if(this.isButtonDisabled == false){
        const updateDate = (date: moment.MomentInput, offset: moment.DurationInputArg1, unit: moment.unitOfTime.Base) => moment(date).add(offset, unit).format('YYYY-MM-DD');
        const daysDifference = moment(this.selectedEndDate).diff(this.selectedStartDate, 'days')+1;
        const offset = (action === 'previous') ? -daysDifference : daysDifference;
        this.selectedStartDate = updateDate(this.selectedStartDate, offset, 'days');
        this.selectedEndDate = updateDate(this.selectedEndDate, offset, 'days');
        this.startDate = this.selectedStartDate;
        this.endDate = this.selectedEndDate;
        this.handleSelectChangeByDestination();
        } else {
            this.isButtonDisabled = false
        }
    }

    dateListDateNavigation(action: string) {
        if (!this.selectedDateListStartDate || !this.selectedDateListEndDate) return;
        this.validateDates("date")
        if(this.isDateListButtonDisabled == false){
        const updateDate = (date: moment.MomentInput, offset: moment.DurationInputArg1, unit: moment.unitOfTime.Base) => moment(date).add(offset, unit).format('YYYY-MM-DD');
        const daysDifference = moment(this.selectedDateListEndDate).diff(this.selectedDateListStartDate, 'days')+1;
        const offset = (action === 'previous') ? -daysDifference : daysDifference;
        this.selectedDateListStartDate = updateDate(this.selectedDateListStartDate, offset, 'days');
        this.selectedDateListEndDate = updateDate(this.selectedDateListEndDate, offset, 'days');
        this.dateListStartDate = this.selectedDateListStartDate;
        this.dateListEndDate = this.selectedDateListEndDate;
        this.handleSelectChangeByDate();
        } else {
            this.isDateListButtonDisabled = false
        }
    }

    validateDates(type:string) {
        if(type === "destination"){
        if (!this.selectedStartDate || !this.selectedEndDate) return;
        if (this.selectedStartDate > this.selectedEndDate) {
            this.selectedStartDate = this.startDate;
            this.selectedEndDate = this.endDate;
            this.isButtonDisabled = true;
        } else {
            this.isButtonDisabled = false;
            this.startDate = this.selectedStartDate;
            this.endDate = this.selectedEndDate;
        }
        }
        else{
        if (!this.selectedDateListStartDate || !this.selectedDateListEndDate) return;
        if (this.selectedDateListStartDate > this.selectedDateListEndDate) {
            this.selectedDateListStartDate = this.dateListStartDate;
            this.selectedDateListEndDate = this.dateListEndDate;
            this.isDateListButtonDisabled = true;
        } else {
            this.isDateListButtonDisabled = false;
            this.dateListStartDate = this.selectedDateListStartDate;
            this.dateListEndDate = this.selectedDateListEndDate;
        }
    }
    }

    get filterShippingDestinationList() {
        return this.includeHiddenFlag ? this.shippingDestinationList : this.shippingDestinationList.filter(s => this.selectedDestinationId == s.id || !s.is_hidden);
    }      

    get filterPlantingsOrCrops() {
        if (this.selectedPlantingsOrCrops) {
            return this.plantingsOrCrops
        } else {
            return this.includeHiddenFlag ? this.plantingsOrCrops : this.plantingsOrCrops.filter(p => this.selectedCropOrPlantingId == p.id || !p.is_hidden);
        }
    }

    get filterDateListPlantingsOrCrops() {
        if (this.selectedDateListPlantingsOrCrops) {
            return this.dateListPlantingsOrCrops
        } else {
            return this.includeHiddenDateListFlag ? this.dateListPlantingsOrCrops : this.dateListPlantingsOrCrops.filter(p => this.selectedDateListCropOrPlantingId == p.id || !p.is_hidden);
        }
    }

    handleSelectChangeByDestination(flag = true) {
        const params = {
            cropId: this.selectedPlantingsOrCrops ? this.selectedCropOrPlantingId : null,
            plantingId: !this.selectedPlantingsOrCrops ? this.selectedCropOrPlantingId : null,
            startDate: this.selectedStartDate,
            endDate: this.selectedEndDate,
            screenName: this.shippingDestinationScreen,
            destinationId: this.selectedDestinationId,
            includeHiddenFlag: this.includeHiddenFlag
        }
        this.$apiClient.doRequest('post', `${this.selectScreenManagement}`, params).then(res => {
            if (flag){
                this.refreshTable('destination');
            }
        }).catch(error=>{
            this.isDestinationSpinnerLoading = false
            this.$toasted.error('データの取得に失敗しました。')
        })
    } 

    handlePlantingsCropSelect(listName:string){
        if(listName === "destination"){
            this.plantingsOrCrops = !this.selectedPlantingsOrCrops ? this.plantings : this.crops
            this.selectedCropOrPlantingId=null
            this.lastSetOption = this.selectedPlantingsOrCrops ? true : false;
            this.handleSelectChangeByDestination();
        }
        else if(listName === "date"){
            this.dateListPlantingsOrCrops = !this.selectedPlantingsOrCrops ? this.plantings : this.crops
            this.selectedDateListCropOrPlantingId=null
            this.lastSetDateListOption = this.selectedDateListPlantingsOrCrops ? true : false;
            this.handleSelectChangeByDate();
        }
      
    }

    getShippingRegisterListByDestination(){
        this.isDestinationSpinnerLoading = true;
        this.shippingRegisterCollectiveDestinationList = [];
        this.$apiClient.doRequest('get', `${this.baseUrl}/${this.shippingDestinationUrl}`).then(res => {
            this.shippingRegisterCollectiveDestinationList = res.shippingRecordRegisterCollectiveDestination;
            if (res.shippingRecordDestinationFilterValues!=null) {
                this.plantingsOrCrops = res.shippingRecordDestinationFilterValues.cropId || this.lastSetOption ? this.crops : this.plantings
                this.selectedPlantingsOrCrops = res.shippingRecordDestinationFilterValues.cropId || this.lastSetOption ? 1 : 0;
                this.selectedCropOrPlantingId = res.shippingRecordDestinationFilterValues.cropId ? res.shippingRecordDestinationFilterValues.cropId : res.shippingRecordDestinationFilterValues.plantingId
                this.selectedStartDate = res.shippingRecordDestinationFilterValues.displayFromDate ? res.shippingRecordDestinationFilterValues.displayFromDate : ""
                this.selectedEndDate = res.shippingRecordDestinationFilterValues.displayToDate ? res.shippingRecordDestinationFilterValues.displayToDate : ""
                this.startDate = res.shippingRecordDestinationFilterValues.displayFromDate ? res.shippingRecordDestinationFilterValues.displayFromDate : ""
                this.endDate = res.shippingRecordDestinationFilterValues.displayToDate ? res.shippingRecordDestinationFilterValues.displayToDate : ""
                this.selectedDestinationId = res.shippingRecordDestinationFilterValues.shippingDestinationId
                this.includeHiddenFlag = res.shippingRecordDestinationFilterValues.includeHiddenFlag
                if ((this.selectedStartDate > this.selectedEndDate) || (this.selectedStartDate === '' && this.selectedEndDate !== '') || (this.selectedStartDate === '' && this.selectedEndDate === '')) {
                    this.isButtonDisabled = true;
                    this.shippingRegisterCollectiveDestinationList = [];
                  }else{
                    this.isButtonDisabled = false;
                }
            }
            this.isDestinationSpinnerLoading = false
        }).catch(error => {
        this.$toasted.error('データの取得に失敗しました。')
        this.shippingRegisterCollectiveDestinationList = [];
        this.isDestinationSpinnerLoading = false;
    })
    }

    formLabel(arr: any): string {
        const result = arr?.split('::').join('<br>');
        return result;
    }


    handleSelectChangeByDate(flag = true) {
        const params = {
            cropId: this.selectedDateListPlantingsOrCrops ? this.selectedDateListCropOrPlantingId : null,
            plantingId: !this.selectedDateListPlantingsOrCrops ? this.selectedDateListCropOrPlantingId : null,
            startDate: this.selectedDateListStartDate,
            endDate: this.selectedDateListEndDate,
            screenName:  this.shippingDatescreen,
            includeHiddenFlag: this.includeHiddenDateListFlag
        }
        this.$apiClient.doRequest('post', `${this.selectScreenManagement}`, params).then(res => {
            if (flag){
                this.refreshTable('date');
            }
        }).catch(error=>{
            this.isDateSpinnerLoading = false;
            this.$toasted.error('データの取得に失敗しました。')
        })
    }

    getShippingRegisterListByDate(flag = true){
        this.isDateSpinnerLoading = true;
        this.shippingRegisterCollectiveDateList = [];
        this.$apiClient.doRequest('get', `${this.baseUrl}/${this.shippingDateUrl}?includeShippingCreationFlag=${this.includeShippingCreationFlag}`).then(res => {
            this.shippingRegisterCollectiveDateList = res.shippingRecordRegisterCollectiveDate;
            if (res.shippingRecordDateFilterValues!=null) {
                this.dateListPlantingsOrCrops = res.shippingRecordDateFilterValues.cropId || this.lastSetDateListOption ? this.crops : this.plantings
                this.selectedDateListPlantingsOrCrops = res.shippingRecordDateFilterValues.cropId || this.lastSetDateListOption ? 1 : 0;
                this.selectedDateListCropOrPlantingId = res.shippingRecordDateFilterValues.cropId ? res.shippingRecordDateFilterValues.cropId : res.shippingRecordDateFilterValues.plantingId
                this.selectedDateListStartDate = res.shippingRecordDateFilterValues.displayFromDate ? res.shippingRecordDateFilterValues.displayFromDate : ""
                this.selectedDateListEndDate = res.shippingRecordDateFilterValues.displayToDate ? res.shippingRecordDateFilterValues.displayToDate : ""
                this.dateListStartDate = res.shippingRecordDateFilterValues.displayFromDate ? res.shippingRecordDateFilterValues.displayFromDate : ""
                this.dateListEndDate = res.shippingRecordDateFilterValues.displayToDate ? res.shippingRecordDateFilterValues.displayToDate : "" 
                this.includeHiddenDateListFlag = res.shippingRecordDateFilterValues.includeHiddenFlag
                if (this.selectedDateListStartDate > this.selectedDateListEndDate) {
                    this.isDateListButtonDisabled = true;
                    this.shippingRegisterCollectiveDateList = [];
                  }else{
                    this.isDateListButtonDisabled = false;
                } 
                if((this.selectedDateListStartDate === '' && this.selectedDateListEndDate !== '') || (this.selectedDateListStartDate === '' && this.selectedDateListEndDate === '')){
                    this.isDateListButtonDisabled = true
                    this.shippingRegisterCollectiveDateList = [];
                }
            }
            this.isDateSpinnerLoading = false
        }).catch(error => {
            this.$toasted.error('データの取得に失敗しました。')
            this.shippingRegisterCollectiveDateList = [];
            this.isDateSpinnerLoading = false;
        })
    }

    sortByDestination(fieldName: string): void {
        this.sortOrderByDestination = !this.sortOrderByDestination;
        this.shippingRegisterCollectiveDestinationList.sort((a:any, b:any) => {
            let aValue: string | number | null = a[fieldName];
            let bValue: string | number | null = b[fieldName];
            
            if (aValue === null && bValue === null) return 0;
            if (aValue === null) return 1;
            if (bValue === null) return -1;
            if (fieldName === 'shippingRegisterCount') {
                aValue = typeof aValue === 'string' ? parseFloat(aValue) : aValue;
                bValue = typeof bValue === 'string' ? parseFloat(bValue) : bValue;
                if (!isNaN(aValue) && !isNaN(bValue)) {
                    return this.sortOrderByDestination ? aValue - bValue : bValue - aValue;
                }
            }
            if (typeof aValue === 'string' && typeof bValue === 'string') 
                return this.sortOrderByDestination ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
            
            if (typeof aValue === 'number' && typeof bValue === 'number') 
                return this.sortOrderByDestination ? aValue - bValue : bValue - aValue;
            return this.sortOrderByDestination ? String(aValue).localeCompare(String(bValue)) : String(bValue).localeCompare(String(aValue));
        });
    }

    sortByDate(fieldName: string): void {
        this.sortOrderByDate = !this.sortOrderByDate;
        this.shippingRegisterCollectiveDateList.sort((a:any, b:any) => {
            let aValue = a[fieldName];
            let bValue = b[fieldName];
            if (aValue === null && bValue === null) return 0;
            if (aValue === null) return 1;
            if (bValue === null) return -1;
            if (fieldName === 'shippingRegisterCount') {
                aValue = typeof aValue === 'string' ? parseFloat(aValue) : aValue;
                bValue = typeof bValue === 'string' ? parseFloat(bValue) : bValue;
                if (!isNaN(aValue) && !isNaN(bValue)) {
                    return this.sortOrderByDate ? aValue - bValue : bValue - aValue;
                }
            }
            if (typeof aValue === 'string' && typeof bValue === 'string') 
                return this.sortOrderByDate ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
            if (typeof aValue === 'number' && typeof bValue === 'number') 
                return this.sortOrderByDate ? aValue - bValue : bValue - aValue;
            return this.sortOrderByDate ? String(aValue).localeCompare(String(bValue)) : String(bValue).localeCompare(String(aValue));
        });
    }

    shippingCollectiveRegisterModal(mode:string, ids:[]){
        this.modeType = mode
        this.shippingCollectiveIds = ids
        this.showShippingCollectiveRegister = true;
        this.$root.$emit('header-inert', true);
    }

    closeShippingCollectiveModal() {
        this.showShippingCollectiveRegister = false;
        this.$root.$emit('header-inert', false);
    }

    private convertDate(date: Date): string {
        if (date) {
            const d = new Date(date);
            return `${d.getFullYear()}/${(d.getMonth() + 1).toString().padStart(2, '0')}/${d.getDate().toString().padStart(2, '0')}`;
        }
        return "-";
    }

    openShippingRecordModal(item:any) {
      this.shippingCollectiveIds = item.shippingRecordCollectiveRegisterId; 
      this.shippingSplitIds = item.shippingSplitId
      this.isShippingModalShow = true
      this.$root.$emit('header-inert', true);
    }

    closeShippingModal() {
        this.shippingCollectiveIds = [];
        this.isShippingModalShow = false;
        this.$root.$emit('header-inert', false);
    }

    private shippingDestination(){
        this.shippingDateTab = false;
        this.shippingDestinationTab = true;

    }
    private shippingDate(){
        this.shippingDestinationTab = false;
        this.shippingDateTab = true;
    }

    formatDigit(input :number){
        const  roundedQuantity = parseFloat(input.toFixed(2));
        return roundedQuantity?.toLocaleString("ja-jp")
    }

}